export default "__VITE_ASSET__DCbY5be4__"